import React, { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

// Components
import TableHead from '@components/Listings/TableHead';
import Typography from '@components/UI-KIT/Typography';

// Material-ui
import {
    Table,
    TableCell,
    TableRow,
    TableContainer,
    TableBody,
    Grid
} from '@material-ui/core';

// Styles
import './HorizontalTable.scss';

interface Props {
    data: {
        label: string;
        value: ReactNode;
        hide?: boolean;
        icon?: ReactNode;
    }[];
    title?: string;
    action?: () => void;
    actionTitle?: string;
    className?: string;
    inProfile?: boolean;
    upperBorder?: boolean;
}

const HorizontalTable: React.FC<Props> = ({
    data,
    title,
    action,
    actionTitle,
    className = '',
    inProfile = false,
    upperBorder = false
}) => {
    return (
        <Grid
            className={`ui-HorizontalTable ${className} ${inProfile ? 'ui-HorizontalTable-profile' : ''}`}
        >
            { title && (
                <TableHead
                    title={title}
                    handleEdit={action}
                    actionTitle={actionTitle}
                />
            )}
            <TableContainer>
                <Table
                    className={`ui-HorizontalTable-table ${upperBorder ? 'ui-HorizontalTable-table-upper-border' : ''}`}
                >
                    <TableBody>
                        {data.map(d => (
                            <React.Fragment
                                key={`ui-HorizontalTable-row-${uuid()}`}
                            >
                                { !d.hide && (
                                    <TableRow>
                                        <TableCell>
                                            { d.icon ? (
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    wrap="nowrap"
                                                    alignItems="center"
                                                >
                                                    <Grid
                                                        item
                                                    >
                                                        {d.icon}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                    >
                                                        <Typography
                                                            variant="table-semibold"
                                                            color="primary-dark"
                                                        >
                                                            {d.label}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                <Typography
                                                    variant="table-semibold"
                                                    color="primary-dark"
                                                >
                                                    {d.label}
                                                </Typography>

                                            )}
                                        </TableCell>
                                        <TableCell
                                            className="ui-HorizontalTable-text"
                                            align="right"
                                        >
                                            { typeof d.value !== 'string' && typeof d.value !== 'number' ? d.value : (
                                                <Typography
                                                    color="primary-dark"
                                                >
                                                    {d.value ? d.value : '-'}
                                                </Typography>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default HorizontalTable;
